import { Popover } from '@/components/Popover';
import { formatFileSize } from '@/utils/storage';

interface StorageTooltipPayload {
    name: string;
    value: number;
    payload: { color: string };
}

interface StorageTooltipProps {
    active?: boolean;
    payload?: StorageTooltipPayload[];
    total: number;
}

export function StorageTooltip({
    active,
    payload,
    total,
}: StorageTooltipProps) {
    if (!active || !payload?.length) return null;
    const slice = payload[0];
    const percent = total > 0 ? ((slice.value / total) * 100).toFixed(1) : '0';
    return (
        <Popover className="text-xs">
            <div className="flex flex-col">
                <div className="flex items-center gap-2">
                    <span
                        className="inline-block size-2 rounded-full"
                        style={{ backgroundColor: slice.payload.color }}
                    />
                    <span className="text-white-100">{slice.name}</span>
                </div>
                <div className="text-grey-300 mt-1">
                    {formatFileSize(slice.value)} ({percent}%)
                </div>
            </div>
        </Popover>
    );
}
